import { useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { StorefrontContext } from '../store/StorefrontContext.jsx';

export default function InfoStrip() {
    const { state: storefrontStateObject } = useContext(StorefrontContext);

    return (
        <Container fluid className="info-strip py-2 bg-body-secondary">
            <Row>
                <Col >
                    Device ID: {storefrontStateObject?.port_no} v1.0.2
                </Col>
                <Col className="text-end">
                    Current Date Time: {new Date().toLocaleString()}
                </Col>
            </Row>
        </Container>
    );
}